import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';
import { EntityFiltersApiService } from '../api';
import { EntityFilters } from '../models';
import { DomainEntityFilters } from '../models/entity-filters';
import { EntityFiltersApi } from '@apps/prtg/api/models';
import { Result204 } from '@common/api/models/result204';
import { NoContentResult } from '@common/domain/models/no-content-result';

@Injectable({
    providedIn: 'root'
})
export class EntityFiltersDomainService extends BaseMiscDomainService
{
    constructor (
        private entityFiltersApiService: EntityFiltersApiService
    )
    {
        super();
    }

    createEntityFilters (entityFilters: EntityFilters): Observable<EntityFilters>
    {
        return this.entityFiltersApiService.createEntityFilters(entityFilters)
            .pipe(
                map(DomainEntityFilters.mapperFromApi)
            );
    }

    retrieveEntityFilters (entityId: string): Observable<NoContentResult<EntityFilters>>
    {
        return this.entityFiltersApiService.retrieveEntityFilters(entityId)
            .pipe(
                map((result: Result204<EntityFiltersApi>): NoContentResult<EntityFilters> =>
                    new NoContentResult(DomainEntityFilters.mapperFromApi(result.value), result.noContent)
                )
            );
    }

    updateEntityFilters (entityFilters: EntityFilters): Observable<EntityFilters>
    {
        return this.entityFiltersApiService.updateEntityFilters(entityFilters)
            .pipe(
                map(DomainEntityFilters.mapperFromApi)
            );
    }

    deleteEntityFilters (entityId: string): Observable<boolean>
    {
        return this.entityFiltersApiService.deleteEntityFilters(entityId);
    }
}
